module.exports = __webpack_public_path__ + "img/img2.f9c940af.jpg";